/* eslint-disable import/prefer-default-export */
import axios from '../../axios';

// ---------------------------------------------------------------------------
// RH / Recrutamento & Seleção — Checklist de documentos de admissão (service
// layer, handoff 0065 §5, Fase 1).
//
// O checklist é GERADO pelo backend (no E2 APROVADO e nas regenerações por
// pré-cadastro/dependentes); o front só trabalha os itens. Cada item tem
// `document_type.collection_kind`: FILE (upload multipart) × VALUE (valor
// textual via PATCH — `value` só é aceito em tipo VALUE, senão 422).
// Permissões: hr:candidate_document:read|manage.
// ---------------------------------------------------------------------------

export async function listDocuments(candidateId) {
   const response = await axios.get(
      `/hr/recruitment/candidates/${candidateId}/documents`,
   );
   return response?.data?.data?.documents ?? [];
}

// Recalcula o checklist (idempotente — só adiciona faltantes).
export async function generateChecklist(candidateId) {
   const response = await axios.post(
      `/hr/recruitment/candidates/${candidateId}/documents/generate`,
   );
   return {
      documents: response?.data?.data?.documents ?? [],
      message: response?.data?.message ?? 'Checklist recalculado.',
   };
}

// patch: { status?, value? } — envia só as chaves presentes. (`notes` foi
// removido do contrato em 2026-07-15 — irrelevante pro checklist.)
export async function updateDocument(documentId, patch = {}) {
   const body = {};
   ['status', 'value'].forEach((key) => {
      if (key in patch) body[key] = patch[key];
   });

   const response = await axios.patch(
      `/hr/recruitment/documents/${documentId}`,
      body,
   );
   return {
      document: response?.data?.data?.document ?? null,
      message: response?.data?.message ?? 'Documento atualizado.',
   };
}

// Upload multipart (campo `file`; PDF/JPEG/PNG/WEBP, ≤10MB) — só p/ tipo FILE;
// o backend seta o status RECEBIDO.
export async function uploadDocumentFile(documentId, file) {
   const formData = new FormData();
   formData.append('file', file);

   const response = await axios.post(
      `/hr/recruitment/documents/${documentId}/file`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
   );
   return {
      document: response?.data?.data?.document ?? null,
      message: response?.data?.message ?? 'Arquivo enviado.',
   };
}

// Download: { url, filename } (URL S3 presigned, ~15min). A página abre a URL
// em nova aba (window.open).
export async function getDocumentDownload(documentId) {
   const response = await axios.get(
      `/hr/recruitment/documents/${documentId}/file`,
   );
   const data = response?.data?.data ?? {};
   return {
      url: data.url ?? null,
      filename: data.filename ?? null,
   };
}
